module.exports = __webpack_public_path__ + "static/Hero-7c022d05794d933207ec671f8841236a.svg";